import { useTranslation } from 'react-i18next';
import type { AccountDetail } from '@/api/accounts';
import cells from '../accountsCells.module.css';
import styles from './accountProfile.module.css';

interface Props {
    detail: AccountDetail;
}

/**
 * EAA-1820 (frame 72): permissions-by-unit table on the overview tab — the
 * handoff shows this inline under identity, not only on the permissions tab.
 */
export function AccountProfilePlacementsTable({ detail }: Props) {
    const { t } = useTranslation();

    if (detail.placements.length === 0) {
        return (
            <p className={`${cells.unassigned} ${styles.placementsEmpty}`}>
                {t('console.accounts.detailDrawer.placementUnassigned')}
            </p>
        );
    }

    return (
        <div className={styles.placementsTableWrap}>
            <table className={`portal-admin-table ${styles.placementsTable}`}>
                <thead>
                    <tr>
                        <th scope="col">{t('console.accounts.profile.placementsTable.unitColumn')}</th>
                        <th scope="col">{t('console.accounts.profile.placementsTable.rolesColumn')}</th>
                        <th scope="col">{t('console.accounts.profile.placementsTable.sourceColumn')}</th>
                    </tr>
                </thead>
                <tbody>
                    {detail.placements.map((p) => (
                        <tr key={p.organization_id + p.level_name}>
                            <td>
                                <strong>{p.organization_name}</strong>
                                {p.level_name && ` · ${p.level_name}`}
                            </td>
                            <td>
                                {p.role_key ? (
                                    <code className={cells.approle}>{p.role_key}</code>
                                ) : (
                                    <span className="portal-accounts-unavailable-cell">—</span>
                                )}
                            </td>
                            <td className={styles.placementsTableSource}>
                                {t('console.accounts.profile.placementsTable.sourceLevel')}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default AccountProfilePlacementsTable;
